import React from "react";
import {Navigate, useLocation} from "react-router";
import {useAppContext} from "../libs/ContextLibs";

export default function AuthenticatedRoute({children}) {
    const {pathname, search} = useLocation();
    const {isAuthenticated} = useAppContext();

    return isAuthenticated ? (
        children
    ) : (
        <Navigate to={
            `/login?redirect=${pathname}${search}`
        } replace />
    );
}